import { tempoApi } from '@/lib/api/tempoApi';
import type { CustomField } from '@/lib/api/types/customField';

export interface UpdateItemTypeFieldsRequest {
  fieldIds: number[];
}

const getFieldsForItemType = async (itemTypeId: number): Promise<CustomField[]> =>
  await tempoApi().get(`api/v1/item-store/item-types/${itemTypeId}/fields`).json<CustomField[]>();

const replaceFieldsForItemType = async (
  itemTypeId: number,
  data: UpdateItemTypeFieldsRequest,
): Promise<CustomField[]> =>
  await tempoApi()
    .put(`api/v1/item-store/item-types/${itemTypeId}/fields`, { json: data })
    .json<CustomField[]>();

export const ItemTypeFieldsApi = {
  getFieldsForItemType,
  replaceFieldsForItemType,
} as const;
